import { render, staticRenderFns } from "./CostPricesAdditionalFeeDetail.vue?vue&type=template&id=c557a6d8"
import script from "./CostPricesAdditionalFeeDetail.vue?vue&type=script&lang=js"
export * from "./CostPricesAdditionalFeeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports